import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';

function Copyright() {
  return (
    <Typography 
      variant="body2" 
      color="text.secondary" 
      sx={{
        color: (theme) => theme.palette.text.secondary,
        fontSize: '0.8125rem',
      }}
    >
      © {new Date().getFullYear()} Mercer LLC.
    </Typography>
  );
}

export default function Footer() {
  return (
      <Box
        component="footer"
        sx={{
          py: 1,
          px: 1,
          textAlign: 'center',
          backgroundColor: (theme) => 
              theme.palette.mode === 'dark' 
                ? theme.palette.grey[800]  // Dark mode color
                : theme.palette.grey[100], // Light mode color
          borderTop: (theme) => 
            `1px solid ${theme.palette.divider}`,
          boxShadow: (theme) =>
            theme.shadows[4], // Subtle shadow
          color: (theme) =>
            theme.palette.mode === 'dark'
              ? theme.palette.common.white
              : theme.palette.text.primary
        }}
      >
        <Container maxWidth="md" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexWrap: 'wrap' }} >
            <Copyright />
            <Box sx={{ mx: 1, color: (theme) => theme.palette.divider }}>|</Box>
            
            <Link 
              href="/privacynotice.pdf" 
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: (theme) => theme.palette.text.secondary,
                textDecoration: 'none',
                fontSize: '0.8125rem',
                '&:hover': { textDecoration: 'underline' },
                mx: 0.5
              }}
            >
              Privacy Notice
            </Link>
            {/* <Link 
              href="https://www.mercer.com/en-my/footer/mercer-cookie-notice/" 
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: (theme) => theme.palette.text.secondary,
                textDecoration: 'none',
                fontSize: '0.8125rem',
                '&:hover': { textDecoration: 'underline' },
                mx: 0.5
              }}
            >
              Cookie Notice
            </Link> */}
        </Container>
      </Box>
  );
}